module.exports = __webpack_public_path__ + "static/mnews06.png";